import { render, staticRenderFns } from "./CPF.vue?vue&type=template&id=1403f156"
import script from "./CPF.vue?vue&type=script&lang=js"
export * from "./CPF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports